export default __webpack_public_path__ + "static/media/IMG_9874.28fed868.jpg";